import PropTypes from 'prop-types';
import React from 'react';

import LazyLoad from 'react-lazyload';
import get from 'lodash/get';

const ReactPropTypes = PropTypes;


class ExternalImage extends React.Component {
	static propTypes = {
	  id: ReactPropTypes.string,
	};

	static defaultProps = {
	  id: '',
	  thumbSize: 'l',
	  link: true,
	};

	render() {
	  let className = 'imagesThumb-image';
	  const thumbSize = this.props.thumbSize;
	  let height;

	  if (this.props.openGallery) {
	    className += ' op-gallery-open';
	  }

	  if (this.props.thumbSize == 't') {
	    className += ' imagesThumb-image--s imagesThumb-image--sExternal';
	    height = 38;
	  } else if (this.props.thumbSize == 'l') {
	    className += ' imagesThumb-image--l imagesThumb-image--lExternal';
	    height = 245;
	  }

	  if (this.props.thumbSize != 't') {
	    return (
  <a
    href={this.props.link}
    target="_blank"
    className={className}
    data-file={this.props.link}
    data-load-local
  >
    <LazyLoad
      once
      height={height}
      offset={100}
      overflow
      placeholder={<img src={`${get(globals, 'staticImageUri', '')}loading.gif`} />}
    >
      <img src={this.props.link} />
    </LazyLoad>
  </a>
	    );
	  }

	  return (
  <div className={className}>
    <img src={this.props.link} />
  </div>
	  );
	}
}

module.exports = ExternalImage;
